productTemplate?.content?.find((item) => item?.type ===
<template>
  <ProductTitledBlock
    v-if="showPropertiesBlock"
    icon=""
    class="mt-6 print:mx-0"
    :title="model.title || $t('shared.catalog.product_details.technical_specs_block_title')"
  >
    <VcCollapsibleContent max-height="12.5rem">
      <div class="space-y-4">
        <VcProperty v-for="property in properties" :key="property.name" :label="property.label!" class="text-base">
          {{ property.value }}
        </VcProperty>
      </div>
    </VcCollapsibleContent>
    <!-- Properties -->
  </ProductTitledBlock>
</template>

<script setup lang="ts">
import { computed, inject } from "vue";
import { configInjectionKey } from "@/core/injection-keys";
import { getPropertiesGroupedByName } from "@/core/utilities";
import ProductTitledBlock from "../product-titled-block.vue";
import type { Product, Property } from "@/core/api/graphql/types";
import { NOT_AVAILABLE_PROPERTIES } from "@/core/constants";

interface IProps {
  product: Product;
  model: {
    title?: string;
    hidden?: boolean;
  };
}

const props = defineProps<IProps>();

const config = inject(configInjectionKey, {});

const mergeProperties = (productProperties: Property[], masterVariantProperties: Property[]) => {
  const hash = new Map();
  masterVariantProperties.concat(productProperties).forEach(function (obj) {
    if (obj.value !== null) {
      hash.set(obj.name, Object.assign(hash.get(obj.name) || {}, obj));
    }
  });

  return Array.from(hash.values()).filter((prop) => !NOT_AVAILABLE_PROPERTIES.includes(prop.name));
};

const properties = computed(() => {
  const productProperties = props.product?.properties ?? [];
  const masterVariantProperties = props.product?.masterVariation?.properties ?? [];
  const mergedProperties = mergeProperties(productProperties, masterVariantProperties);

  return Object.values(getPropertiesGroupedByName(mergedProperties));
});

const showPropertiesBlock = computed(() => !props.model.hidden && properties.value.length);
</script>
